import { cn } from "@/lib/utils";

interface TasksCompletionArcProps {
  completed: number;
  pending: number;
  overdue: number;
  className?: string;
}

export function TasksCompletionArc({
  completed,
  pending,
  overdue,
  className,
}: TasksCompletionArcProps) {
  const total = Math.max(0, completed + pending + overdue);
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  const r = 54;
  const c = Math.PI * r;
  const dash = (pct / 100) * c;

  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div className="relative w-[200px] h-[118px]">
        <svg viewBox="0 0 140 86" className="w-full h-full" aria-hidden>
          <path
            d="M16 78 A 54 54 0 0 1 124 78"
            fill="none"
            stroke="hsl(var(--muted))"
            strokeWidth="12"
            strokeLinecap="round"
          />
          <path
            d="M16 78 A 54 54 0 0 1 124 78"
            fill="none"
            stroke="hsl(var(--primary))"
            strokeWidth="12"
            strokeLinecap="round"
            strokeDasharray={`${dash} ${c}`}
            className="transition-[stroke-dasharray] duration-500 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
          <p className="text-3xl font-semibold tabular-nums leading-none tracking-tight">{pct}%</p>
          <p className="text-xs text-muted-foreground mt-1">concluído</p>
        </div>
      </div>
      <ul className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground mt-2">
        <li className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-primary" />
          Feitas {completed}
        </li>
        <li className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-muted-foreground/40" />
          Em aberto {pending}
        </li>
        <li className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-destructive" />
          Atrasadas {overdue}
        </li>
      </ul>
    </div>
  );
}
